/**
 * Loading placeholders (§12). Initial loads show ghost geometry, never a
 * spinner. `animate-pulse` is neutralized by the global prefers-reduced-motion
 * guard. Purely decorative → aria-hidden (the surrounding pane is brief and
 * needs no live announcement).
 */

const BAR = 'rounded-corner-xs bg-on-surface/[0.08]';

/** Conversation-list ghost: N rows matching TicketRow's 76px two-line layout. */
export function ListSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-0.5" aria-hidden="true" data-testid="list-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-start gap-3 px-3 py-2.5 min-h-[76px] animate-pulse">
          <span className="shrink-0 mt-0.5 w-10 h-10 rounded-corner-full bg-on-surface/[0.08]" />
          <div className="flex-1 min-w-0 flex flex-col gap-2 pt-1">
            <div className="flex items-center justify-between gap-2">
              <div className={`h-3.5 w-32 ${BAR}`} />
              <div className={`h-3 w-10 ${BAR}`} />
            </div>
            <div className={`h-3 w-3/4 ${BAR}`} />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Chat-thread ghost: three bubbles (customer, agent, customer) on the surface. */
export function ChatSkeleton() {
  const rows: { own: boolean; w: string }[] = [
    { own: false, w: 'w-48' },
    { own: true, w: 'w-40' },
    { own: false, w: 'w-56' },
  ];
  return (
    <div className="mx-auto max-w-[880px] w-full px-6 py-4 flex flex-col gap-4" aria-hidden="true" data-testid="chat-skeleton">
      {rows.map((r, i) => (
        <div key={i} className={`flex ${r.own ? 'justify-end' : 'justify-start'} animate-pulse`}>
          <div className={`h-12 ${r.w} max-w-[65%] rounded-corner-lg bg-on-surface/[0.08]`} />
        </div>
      ))}
    </div>
  );
}
